.root {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: center;
  gap: var(--space-2);
  inline-size: 100%;
  max-inline-size: 37.5rem;
  padding-block: var(--space-1);
}

.slider {
  flex: 1;
  min-inline-size: 0;
}
